import React from 'react';
import moment from 'moment';
import displayName from 'component-lib/displayName';

import WeekdayBox from './WeekdayBox';

import styles from '../Datepicker.scss';

export default function DatePickerWeekdays() {
    return (
        <div className={styles['datepicker-block']}>
            {
                moment.weekdaysMin().map(weekday => <WeekdayBox key={weekday} text={weekday} />,)
            }
        </div>
    );
}

DatePickerWeekdays.displayName = displayName('Widgets/Datepicker/Weekdays');
